var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageBotErrorIbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 199,
    viewBox: "0 0 240 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.595 83.1306C229.241 67.1708 214.898 54.0764 198.322 52.4851C182.673 50.9819 167.57 59.2143 151.852 59.3611C126.437 59.596 105.342 39.1853 80.4429 34.018C51.5068 28.011 19.5722 46.2081 9.63682 74.3756C3.22205 92.5609 6.50484 113.418 16.678 129.654H230.018C237.28 115.391 239.675 98.2977 234.589 83.1365L234.595 83.1306Z",
    fill: "url(#paint0_linear_13325_393016)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.888 14.7501C220.888 14.0682 220.736 13.3981 220.45 12.7873C220.163 12.1765 219.741 11.6488 219.229 11.2396C218.711 10.8304 218.115 10.5517 217.479 10.4331C216.843 10.3086 216.19 10.3442 215.571 10.5339C215.178 8.99218 214.289 7.6461 213.051 6.72697C211.813 5.80783 210.311 5.37495 208.803 5.49948C207.295 5.62401 205.877 6.30594 204.791 7.41483C203.711 8.52965 203.03 10.0062 202.873 11.5895C202.288 11.3641 201.669 11.2811 201.05 11.3404C200.431 11.3997 199.834 11.6073 199.306 11.9453C198.777 12.2833 198.321 12.7399 197.978 13.2854C197.634 13.831 197.415 14.4536 197.331 15.1V15.1533C197.331 15.1889 197.314 15.2719 197.308 15.3312C197.308 15.3905 197.291 15.5625 197.291 15.7107C197.291 16.2859 197.398 16.8552 197.606 17.3889C197.815 17.9226 198.124 18.4029 198.512 18.8121C198.9 19.2212 199.356 19.5414 199.863 19.7608C200.369 19.9802 200.909 20.0929 201.455 20.087H216.415C217.068 20.087 217.715 19.9328 218.3 19.6304C218.885 19.328 219.403 18.8892 219.802 18.3436C220.495 17.3889 221.102 16.114 220.888 14.7323V14.7501Z",
    fill: "url(#paint1_linear_13325_393016)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9183 13.8929C49.9183 12.8731 49.6891 11.8653 49.2483 10.948C48.8075 10.0368 48.161 9.24024 47.3616 8.62471C46.5682 8.00919 45.6454 7.59883 44.6639 7.4178C43.6882 7.23676 42.6773 7.29107 41.7251 7.57469C41.1198 5.26344 39.7503 3.24789 37.846 1.872C35.9417 0.496117 33.6319 -0.155621 31.3103 0.0314516C28.9887 0.224559 26.8082 1.23837 25.1448 2.90995C23.4815 4.58154 22.4353 6.79623 22.2002 9.17386C21.3069 8.83592 20.343 8.7092 19.3967 8.79972C18.4445 8.89024 17.5277 9.20404 16.7107 9.70491C15.8937 10.2118 15.1943 10.8998 14.6712 11.7144C14.1481 12.5351 13.8072 13.4645 13.6779 14.436V14.5205C13.6779 14.5748 13.6544 14.7015 13.6485 14.7921C13.6309 14.9369 13.625 15.13 13.6191 15.3593C13.6191 16.2223 13.7837 17.0792 14.107 17.8757C14.4302 18.6723 14.9004 19.3965 15.4941 20.006C16.0877 20.6154 16.7989 21.0982 17.5747 21.4241C18.3505 21.7499 19.1851 21.9189 20.0256 21.9129H43.0417C44.0467 21.9129 45.04 21.6775 45.9393 21.2249C46.8444 20.7724 47.632 20.1146 48.2491 19.2999C49.3188 17.8637 50.2592 15.9507 49.9183 13.8748V13.8929Z",
    fill: "url(#paint2_linear_13325_393016)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1876 96.1683C30.1876 95.496 29.692 94.9558 29.0753 94.9558C28.4585 94.9558 27.9628 95.496 27.9628 96.1683V101.048C27.9628 101.72 28.4585 102.261 29.0753 102.261C29.692 102.261 30.1876 101.72 30.1876 101.048V96.1683ZM29.0808 96.3603C33.6019 96.3603 37.264 92.3688 37.264 87.4409C37.264 82.513 33.6019 78.5215 29.0808 78.5215C24.5596 78.5215 20.8975 82.513 20.8975 87.4409C20.8975 92.3688 24.5596 96.3603 29.0808 96.3603Z",
    fill: "#E8F5EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.305 76.2393H158.922C155.969 76.2393 153.575 78.792 153.575 81.941V123.94C153.575 127.089 155.969 129.641 158.922 129.641H198.305C201.258 129.641 203.652 127.089 203.652 123.94V81.941C203.652 78.792 201.258 76.2393 198.305 76.2393Z",
    stroke: "url(#paint3_linear_13325_393016)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6646 67.1496V50.7129C63.6646 46.6144 66.8799 43.2891 70.8427 43.2891H86.4269",
    stroke: "#94AA96",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.922 67.1504H50.5762C47.7457 67.1504 45.4512 69.3936 45.4512 72.1606V142.811C45.4512 145.579 47.7457 147.822 50.5762 147.822H102.922C105.753 147.822 108.047 145.579 108.047 142.811V72.1606C108.047 69.3936 105.753 67.1504 102.922 67.1504Z",
    fill: "url(#paint4_linear_13325_393016)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.047 79.6475H45.4512V80.7837H108.047V79.6475Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2422 151.491C86.2422 156.65 90.4354 160.836 95.603 160.836H188.185C193.352 160.836 197.545 156.65 197.545 151.491V44.542H86.2422V151.491Z",
    fill: "url(#paint5_linear_13325_393016)",
    fillOpacity: 0.85
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.185 32H95.603C90.4354 32 86.2422 36.1862 86.2422 41.3452V44.5356H197.545V41.3452C197.545 36.1862 193.352 32 188.185 32Z",
    fill: "url(#paint6_linear_13325_393016)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.637 120.552H116.106C115.662 120.552 115.303 120.16 115.303 119.673V111.953C115.303 111.466 115.662 111.074 116.106 111.074H184.637C185.082 111.074 185.44 111.466 185.44 111.953V119.673C185.44 120.16 185.082 120.552 184.637 120.552ZM139.196 109.721V106.129C139.196 105.939 139.058 105.781 138.879 105.781H115.615C115.442 105.781 115.298 105.933 115.298 106.129V109.721C115.298 109.91 115.436 110.068 115.615 110.068H138.879C139.052 110.068 139.196 109.917 139.196 109.721ZM105.009 106.224C101.658 106.224 98.9434 109.196 98.9434 112.863C98.9434 116.531 101.658 119.502 105.009 119.502C108.36 119.502 111.075 116.531 111.075 112.863C111.075 109.196 108.36 106.224 105.009 106.224Z",
    fill: "url(#paint7_linear_13325_393016)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.637 97.8275H116.106C115.662 97.8275 115.303 97.4958 115.303 97.0838V90.551C115.303 90.139 115.662 89.8073 116.106 89.8073H184.637C185.082 89.8073 185.44 90.139 185.44 90.551V97.0838C185.44 97.4958 185.082 97.8275 184.637 97.8275ZM139.196 88.6624V85.6234C139.196 85.4629 139.058 85.3291 138.879 85.3291H115.615C115.442 85.3291 115.298 85.4575 115.298 85.6234V88.6624C115.298 88.8229 115.436 88.9566 115.615 88.9566H138.879C139.052 88.9566 139.196 88.8282 139.196 88.6624ZM105.009 85.7036C101.658 85.7036 98.9434 88.2183 98.9434 91.3215C98.9434 94.4247 101.658 96.9393 105.009 96.9393C108.36 96.9393 111.075 94.4247 111.075 91.3215C111.075 88.2183 108.36 85.7036 105.009 85.7036Z",
    fill: "url(#paint8_linear_13325_393016)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.637 139.867H116.106C115.662 139.867 115.303 139.535 115.303 139.123V132.59C115.303 132.178 115.662 131.846 116.106 131.846H184.637C185.082 131.846 185.44 132.178 185.44 132.59V139.123C185.44 139.535 185.082 139.867 184.637 139.867ZM139.196 130.701V127.662C139.196 127.502 139.058 127.368 138.879 127.368H115.615C115.442 127.368 115.298 127.497 115.298 127.662V130.701C115.298 130.862 115.436 130.996 115.615 130.996H138.879C139.052 130.996 139.196 130.867 139.196 130.701ZM105.009 127.743C101.658 127.743 98.9434 130.257 98.9434 133.361C98.9434 136.464 101.658 138.978 105.009 138.978C108.36 138.978 111.075 136.464 111.075 133.361C111.075 130.257 108.36 127.743 105.009 127.743Z",
    fill: "url(#paint9_linear_13325_393016)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.608 67.1504H99.7752C99.3158 67.1504 98.9434 67.5411 98.9434 68.023V75.3675C98.9434 75.8494 99.3158 76.2401 99.7752 76.2401H184.608C185.068 76.2401 185.44 75.8494 185.44 75.3675V68.023C185.44 67.5411 185.068 67.1504 184.608 67.1504Z",
    fill: "url(#paint10_linear_13325_393016)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.608 55.7871H99.7752C99.3158 55.7871 98.9434 56.0801 98.9434 56.4416V61.9499C98.9434 62.3114 99.3158 62.6044 99.7752 62.6044H184.608C185.068 62.6044 185.44 62.3114 185.44 61.9499V56.4416C185.44 56.0801 185.068 55.7871 184.608 55.7871Z",
    fill: "url(#paint11_linear_13325_393016)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 112.313,
    width: 240,
    height: 53.6862,
    fill: "url(#paint12_linear_13325_393016)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.07,
    y: 53.5146,
    width: 44.5714,
    height: 30.6778,
    rx: 4,
    fill: "url(#paint13_linear_13325_393016)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13325_393016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 154C135.121 154 149 140.121 149 123C149 105.879 135.121 92 118 92C100.879 92 87 105.879 87 123C87 140.121 100.879 154 118 154Z",
    fill: "url(#paint14_linear_13325_393016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.244 113.63L118.357 119.541L112.471 113.63C111.253 112.407 109.286 112.407 108.068 113.63C106.851 114.853 106.851 116.827 108.068 118.051L113.955 123.962L108.068 129.873C106.851 131.096 106.851 133.07 108.068 134.293C109.286 135.516 111.253 135.516 112.471 134.293L118.357 128.382L124.244 134.293C125.462 135.516 127.428 135.516 128.646 134.293C129.864 133.07 129.864 131.096 128.646 129.873L122.759 123.962L128.646 118.051C129.864 116.827 129.864 114.853 128.646 113.63C127.428 112.407 125.462 112.407 124.244 113.63Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13325_393016",
    x: 67,
    y: 77,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.423529 0 0 0 0 0.282353 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13325_393016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13325_393016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13325_393016",
    x1: 121.637,
    y1: 38.0847,
    x2: 122.169,
    y2: 315.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233302,
    stopColor: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471902,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13325_393016",
    x1: 209.093,
    y1: 6.26548,
    x2: 209.211,
    y2: 48.1495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233302,
    stopColor: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471902,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13325_393016",
    x1: 31.7754,
    y1: 1.18045,
    x2: 31.9487,
    y2: 64.0065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233302,
    stopColor: "#F8FAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471902,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13325_393016",
    x1: 203.652,
    y1: 97.9436,
    x2: 178.614,
    y2: 98.1045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94AA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94AA96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13325_393016",
    x1: -42.1881,
    y1: -128.997,
    x2: 114.556,
    y2: 97.2326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#456C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13325_393016",
    x1: 141.891,
    y1: 249.783,
    x2: 141.891,
    y2: 124.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13325_393016",
    x1: 53.6489,
    y1: 27.2926,
    x2: 55.5317,
    y2: 53.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#456C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13325_393016",
    x1: 142.192,
    y1: 105.781,
    x2: 208.651,
    y2: 187.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13325_393016",
    x1: 142.192,
    y1: 85.3291,
    x2: 195.83,
    y2: 163.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13325_393016",
    x1: 142.192,
    y1: 127.368,
    x2: 195.83,
    y2: 205.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13325_393016",
    x1: 142.192,
    y1: 67.1504,
    x2: 175.613,
    y2: 134.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13325_393016",
    x1: 142.192,
    y1: 55.7871,
    x2: 162.793,
    y2: 110.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13325_393016",
    x1: 120,
    y1: 112.313,
    x2: 120,
    y2: 166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13325_393016",
    x1: 128.001,
    y1: 15.3271,
    x2: 164.675,
    y2: 101.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#566C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E0C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13325_393016",
    x1: 68.8443,
    y1: 68.7174,
    x2: 127.739,
    y2: 160.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#456C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E0C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBotErrorIbank);
export default __webpack_public_path__ + "static/media/image_bot_error_ibank.2eaff2358889fa5aeba3aa02f702985d.svg";
export { ForwardRef as ReactComponent };